<template>
  <page-article :page-title="title">
    <ul>
      <li>
        一、  隱私權政策的適用範圍及個人資料安全之保護 本隱私權政策內容，
        為國立臺灣科技大學（以下簡稱本校）於包括使用本網站時，
        如何處理您使用本網站時所蒐集到的個人資料，不適用於使用本網站以外的相關業務，
        也不適用於非本校所委託或參與管理的人員，
        本校亦將依循個人資料保護法為保護您之個人資料安全踐行告知義務。
      </li>
      <li>
        二、  個人資料之蒐集、處理和利用<br>
        <ul>
          <li>
            （一）蒐集之目的與個人資料之類別<br>
            本網站為提供您最佳的互動性服務，可能會請您提供相關個人資料，其範圍如下：<br>
            當您使用本網站之各項功能時，本校會保留您所提供的個人資料
            （包含電子郵件地址、單位、統編、公司名稱、負責人、員工數、資本額、聯絡人、聯絡電話、傳真、地址等）。<br>
            本網站所蒐集之個人資料
            （包含電子郵件地址、單位、統編、公司名稱、負責人、員工數、資本額、聯絡人、聯絡電話、傳真、地址等）等
            資訊為必填欄位，將作為人事管理用途(002人事管理、109教育或訓練行政)。
          </li>
          <li>
            （二）個人資料利用之期間、地區、對象及方式<br>
            本網站所蒐集、處理與利用您的個人資料之期間為：
            自即日起至本校履行法定義務完畢、執行職務或業務所必須期間、期間屆滿、解除或終止之日止；
            但若法律另有規定或個人資料之利用期間之延長，則不在此限，利用地區為台灣地區(如為國外地區，請填寫國家名稱)。<br>
            為提供精確的服務，本校會使用本網站之蒐集資料分析結果以統計數據或說明文字呈現；
            除供內部研究外，本校會視需要公布統計數據及說明文字，但不涉及特定個人之資料。<br>
            使用本網站於一般瀏覽時，伺服器會自行記錄相關行徑，
            包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料紀錄等，
            做為本校增進網站服務的參考依據，此紀錄為內部應用，絕不對外公布。
          </li>
          <li>
            （三）當事人依個資法規定得行使之權利及方式<br>
            您可自由選擇是否提供您的個人資料，但若您所提供之個人資料，
            經檢舉或由本校發現不足以確認您的身分，或有其他個人資料冒用、盜用、資料不實等情形，
            您將損失參與本網站相關之權益。<br>
            您可隨時依個人資料保護法之相關規定，
            向本校查詢本網站所蒐集您的個人資料、要求補充或更正、請求停止蒐集處理或利用、請求查閱、複製、刪除。<br>
            如您要求本網站停止蒐集、處理、利用或刪除您的個人資料，
            因而造成本校無法履行法定義務、執行職務或業務，致影響本校或您個人相關權益時，本校保留准駁權。<br>
            除非取得您的同意或其他法令之特別規定，
            使用本網站絕不會將您的個人資料揭露予第三人或使用於蒐集目的以外之其他用途。<br>
            若本校需要於對外網站或網頁公布您的個人資料時，將進行適當遮蔽作業，並依相關法律及規範之要求處理。<br>
            除非取得您的同意，本校不會利用您所提供之個人資料進行行銷活動，
            如有接收行銷活動之訊息，您可透過「個人資料保護服務電話」或「服務信箱」等方式向本校提出拒絕行銷之請求。
          </li>
        </ul>
      </li>
      <li>
        三、  資料之保護<br>
        本網站主機均設有防火牆、防毒系統等相關的各項安全設備及必要的安全防護措施，
        加以保護您的個人資料，只有經過授權的人員才能接觸您的個人資料，相關處理人員皆簽有保密合約，
        如有違反保密義務者，將會受到相關的法律處分。<br>
        如因業務需要有必要委託本網站相關單位提供服務時，本校亦嚴格要求遵守保密義務，並採取必要檢查程序以確實遵守。
      </li>
      <li>四、  本網站網頁提供其他網站的網路連結，但該連結網站不適用本網站的隱私權政策。</li>
      <li>
        五、  為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的Cookie，
        若您不願接受Cookie的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，
        即可拒絕Cookie的寫入，但可能會導致網站某些功能無法正常執行。
      </li>
      <li>
        六、  本隱私權暨告知事項政策聲明可能會因應個人資料保護法或其他相關法規、
        以及實際需求隨時進行修正，修正後的條款將刊登於本網站相關說明。
      </li>
    </ul>
  </page-article>
</template>
<script>
import pageArticle from '~components/pages/Article'
export default {
  name: 'PrivacyPolicyContent',
  components: {
    pageArticle
  },
  data () {
    return {
      title: '隱私權政策的適用範圍及個人資料安全之保護聲明'
    }
  }
}
</script>
